import React from 'react';
import { createRoot } from 'react-dom/client';
import ResultsContainer from './ResultsContainer';

const IMPORTANT_BODY_CONTAINER_CHILDREN_IDS = [
  'shopify-section-header',
  'shopify-section-footer',
  'overlay-mask',
  'modal-container',
  'top',
];

const clearOldPageContents = (): void => {
  const bodyContainer = document.querySelector('.body-container');
  for (const childElement of Array.from(bodyContainer.children).filter(
    child => !IMPORTANT_BODY_CONTAINER_CHILDREN_IDS.includes(child.id)
  )) {
    bodyContainer.removeChild(childElement);
  }
};

const createPageContainer = (): Element => {
  clearOldPageContents();

  const pageContainer = document.createElement('div');
  pageContainer.className = 'page-container';
  pageContainer.id = 'PageContainer';

  const shopifyHeaderSection = document.getElementById('shopify-section-header');
  shopifyHeaderSection.parentNode.insertBefore(pageContainer, shopifyHeaderSection.nextSibling);

  return pageContainer;
};

const appendResults = ({ term, priceRange }: { term: string; priceRange: { min: number; max: number } }) => {
  createRoot(createPageContainer()).render(
    <main className="main-content" id="MainContent" role="main">
      <div id="search-results-container">
        <ResultsContainer term={term} priceRange={priceRange} />
      </div>
    </main>
  );

  window.history.pushState(
    {},
    null,
    `/search?query=${term}&page=1${
      priceRange?.min && priceRange?.max
        ? `&range[facets.Price][min]=${priceRange.min}&range[facets.Price][max]=${priceRange.max}`
        : ''
    }`
  );
};

export default appendResults;
